module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.d2b3c571.svg";